import { Route } from '@angular/router';
import {ConsoleLayoutComponent} from "./components/console-layout/console-layout.component";
import {AuthFacade} from "@auth/lib/+state/auth.facade";
import {isAuthenticatedGuard} from "@auth/guards/is-authenticated/is-authenticated.guard";
import {CoreUiFacade} from "@core/lib/+state/core-ui.facade";

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () => import('@auth/lib/lib.routes').then(m => m.authRoutes),
  },
  {
    path: 'console',
    data: { breadcrumb: 'Home' },
    component: ConsoleLayoutComponent,
    canActivate: [isAuthenticatedGuard],
    providers: [
      CoreUiFacade,
      AuthFacade
    ],
    children: [
      {
        path: 'digitization',
        data: { breadcrumb: 'Preservation, Digitization and Reproduction' },
        loadChildren: () => import('@digitization').then(m => m.digitizationReproductionRoutes)
      }
    ]
  },
  {
    path: 'settings',
    data: { breadcrumb: 'Settings' },
    component: ConsoleLayoutComponent,
    canActivate: [isAuthenticatedGuard],
    loadChildren: () => import('@settings/lib/lib.routes').then(m => m.settingsRoutes),
    providers: [
      CoreUiFacade,
      AuthFacade
    ],
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full'
  }
];
